import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  LOGIN_FORM,
  EMPTY_STRING,
  configurationsConstants,
} from "../../../../constants";
import { assetsConstants } from "../../../../constants/assets.constants";
import SideImage from "../../../../shared/components/SideImage/SideImage";
import { loginActions } from "../../../../redux/actions";

const ForgotPassword = (props) => {
  const { t } = useTranslation("common");

  // when user clicks on Login button
  const handleSubmit = (event, values) => {
    props.forgotPassword({ userTypeId: 2, ...values }, props.setIsModalOpen);
  };

  return (
    <>
      <SideImage
        imageUrl={assetsConstants.CUSTOMER_LOGIN_IMAGE_URL}
        showBackButton={props.showBackButton ?? true}
        shouldShowCenter={props.isAllowModal ? false : true}
        isAllowModal={props.isAllowModal}
      >
        <div
          className={`login-form ${
            props.isAllowModal ? "login-form-modal px-3 pb-4" : EMPTY_STRING
          }`}
        >
          {!props.isPage && (
            <button
              id="cancel-icon"
              onClick={() => props.setIsModalOpen(false)}
            >
              <span>X</span>
            </button>
          )}
          <AvForm
            className="form_Display_Flex"
            onValidSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className={`${props.isAllowModal ? "pt-0" : "mb-md-4 pt-2 pt-sm-4"}`}>
              <div className="d-flex align-items-center position-relative my-md-2 my-4">
                <h2 className="text-center form-heading w-100 mb-0 pt-md-5">
                  forgot password
                </h2>
              </div>
            </div>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <div className="my-2">
                  <AvField
                    required
                    type="email"
                    name="email"
                    maxLength={configurationsConstants.EMAIL_INPUT_LENGTH}
                    placeholder="enter your email"
                    errorMessage={t("this_field_is_required")}
                  />
                </div>
              </div>
            </div>
            <div className="form__form-group mb-4">
              <div className="form__form-group-field">
                <div className="account__btns ml-0">
                  <button className="btn-teal w-100">submit</button>
                </div>
              </div>
            </div>
          </AvForm>

          {props.isAllowModal && (
            <div className="form__form-group align-self-center">
              <p className="p-0 m-0 sign-up-shutterb ">
                Already have an account{" "}
                <Link
                  onClick={(e) => {
                    if (props.isAllowModal) {
                      e.preventDefault();
                      props.setFormSelect(LOGIN_FORM);
                    }
                  }}
                  className="underline teal-text"
                >
                  Login Here
                </Link>
              </p>
            </div>
          )}
        </div>
      </SideImage>
    </>
  );
};

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  forgotPassword: (data, setIsModalOpen) =>
    dispatch(loginActions.forgotPassword(data, setIsModalOpen)),
});

// mapping action and store the function via props
export default connect(null, mapDispatchToProps)(withRouter(ForgotPassword));
